import { File, FileText, Image as ImageIcon } from 'lucide-react';

function getFileTypeFromMime(mime: string): 'pdf' | 'doc' | 'img' | 'outro' {
  if (mime === 'application/pdf') return 'pdf';
  if (mime.startsWith('image/')) return 'img';
  if (
    mime.includes('msword') ||
    mime.includes('wordprocessingml') ||
    mime.includes('opendocument.text')
  )
    return 'doc';
  return 'outro';
}

function getExtFromMime(mime: string): string {
  if (mime === 'application/pdf') return 'PDF';
  if (mime.includes('msword') || mime.includes('wordprocessingml')) return 'DOC';
  if (mime.includes('opendocument.text')) return 'ODT';
  if (mime.includes('spreadsheet') || mime.includes('excel')) return 'XLS';
  if (mime === 'image/jpeg') return 'JPG';
  if (mime === 'image/png') return 'PNG';
  if (mime === 'image/webp') return 'WEBP';
  if (mime.startsWith('image/')) return 'IMG';
  if (mime === 'audio/mpeg') return 'MP3';
  if (mime === 'audio/wav') return 'WAV';
  if (mime === 'audio/ogg') return 'OGG';
  if (mime.startsWith('audio/')) return mime.split('/').pop()?.toUpperCase() || 'AUD';
  if (mime === 'video/mp4') return 'MP4';
  if (mime === 'video/webm') return 'WEBM';
  if (mime.startsWith('video/')) return mime.split('/').pop()?.toUpperCase() || 'VID';
  return '';
}

const MIME_ICON_MAP: Record<string, typeof FileText> = {
  pdf: FileText,
  doc: FileText,
  img: ImageIcon,
  outro: File,
};

export function FileTypeIcon({ mime, size = 'sm' }: { mime: string; size?: 'sm' | 'lg' }) {
  const tipo = getFileTypeFromMime(mime);
  const Icon = MIME_ICON_MAP[tipo] ?? File;
  const ext = getExtFromMime(mime);
  const isLg = size === 'lg';
  const wrapCls = isLg ? 'h-12 w-12 rounded-lg' : 'h-10 w-10 rounded-full';
  // Com a sigla a 11px (piso de legibilidade), o ícone pequeno cede 4px para
  // a sigla caber dentro do círculo de 40px sem vazar pelas bordas.
  const iconCls = isLg ? 'h-6 w-6' : ext ? 'h-4 w-4' : 'h-5 w-5';

  return (
    <div className={`flex shrink-0 flex-col items-center justify-center gap-0 bg-muted ${wrapCls}`}>
      <Icon className={`${iconCls} text-muted-foreground`} />
      {ext && (
        <span className="text-[11px] font-medium uppercase leading-none tracking-tight text-muted-foreground/70">
          {ext}
        </span>
      )}
    </div>
  );
}
